<script setup lang="ts">
/**
 * On Board — 문서 포함 여부(YES/NO) 토글.
 *   한 task 에서 이 문서를 생성할지 운영자가 선택(DR 3종처럼 안 할 수도 있는 문서).
 *   미설정(unset) = 포함(기본), 'no' 일 때만 제외. 패널 createTask 가 이 플래그를 읽어 skip.
 */
import { computed, inject } from 'vue';
import { useAgmFill, DOC_SCOPE } from '../cdd/useCddFill';

const props = defineProps<{ flag: string }>();
const fill = useAgmFill();
const scope = inject(DOC_SCOPE, '');
const key = computed(() => scope + props.flag);
const included = computed(() => String(fill.getValue(key.value) ?? '').toLowerCase() !== 'no');
function toggle() { fill.setValue(key.value, included.value ? 'no' : 'yes'); }
</script>

<template>
  <div class="include-row" :class="{ excluded: !included }">
    <span class="include-toggle" @click="toggle">
      <span class="inc-mark">{{ included ? '☒' : '☐' }}</span>
      Include this document in the task
    </span>
    <span v-if="!included" class="excluded-badge">Excluded — will not be generated</span>
  </div>
</template>

<style scoped>
.include-row {
  display: flex; align-items: center; gap: 12px;
  margin: 0 0 12px; padding: 8px 12px; border: 1px solid #d7e0f0; border-radius: 8px; background: #f6f9ff;
}
.include-row.excluded { background: #f6f7f9; border-color: #e0e3e8; opacity: 0.85; }
.include-toggle { cursor: pointer; font-weight: 700; font-size: 12px; color: #1f2d4d; user-select: none; }
.include-row.excluded .include-toggle { color: #8a94a6; }
.inc-mark { font-size: 14px; margin-right: 4px; }
.excluded-badge { font-size: 11px; font-weight: 700; color: #c0392b; }
</style>
